import { render, staticRenderFns } from "./textCards.vue?vue&type=template&id=680663a2&scoped=true"
import script from "./textCards.vue?vue&type=script&lang=js"
export * from "./textCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680663a2",
  null
  
)

export default component.exports